import React from "react"

/**
 * InertiaPageFooter renders layout elements that should appear after the main content.
 * This includes bottom alerts, conversion tracking scripts, and modals.
 *
 */
export function InertiaPageFooter() {
  return <></>
}
